import { MapPin, FileCheck2, Stethoscope, ShieldCheck, Star, Clock, HeartPulse, Truck, BadgeCheck, Users } from "lucide-react";

export const LANDING_ICONS = {
  MapPin,
  FileCheck2,
  Stethoscope,
  ShieldCheck,
  Star,
  Clock,
  HeartPulse,
  Truck,
  BadgeCheck,
  Users,
};

export const ICON_OPTIONS = Object.keys(LANDING_ICONS);

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Resolve a stored image reference: external http(s) URL as-is, else a storage path via the file endpoint.
export const resolveLandingImg = (url, fallback) => {
  if (!url) return fallback;
  if (url.startsWith("http")) return url;
  return `${BACKEND}/api/files/${url}`;
};
